/**
 * DynamicAdapter - Motor de Adaptación Dinámica de Dificultad en Vivo
 * Inspirado en la IA de Smartick / Innovamat
 */

class DynamicAdapterManager {
    constructor() {
        this.resetState();
    }

    resetState() {
        this.consecutiveFailures = 0;
        this.consecutiveSuccesses = 0;
        this.activeHelpLevel = 0; // 0 = Normal, 1 = Pistas Cromáticas, 2 = Asistencia Total
    }

    /**
     * Registrar un intento en cualquier paso del problema
     * @param {boolean} isSuccess 
     * @param {number} stepNumber 
     * @param {object} context 
     */
    registerAttempt(isSuccess, stepNumber, context = {}) {
        if (isSuccess) {
            this.consecutiveFailures = 0;
            this.consecutiveSuccesses++;

            // Recompensar racha positiva (3 aciertos seguidos)
            if (this.consecutiveSuccesses >= 3) {
                this.triggerPositiveReinforcement(stepNumber);
            }
        } else {
            this.consecutiveSuccesses = 0;
            this.consecutiveFailures++;

            // Activar ayuda adaptativa tras 2 fallos seguidos
            if (this.consecutiveFailures >= 2) {
                this.triggerAdaptiveAssistance(stepNumber, context);
            }
        }
    }

    /**
     * Activa la ayuda adaptativa progresiva
     */
    triggerAdaptiveAssistance(stepNumber, context) {
        this.activeHelpLevel = Math.min(2, this.activeHelpLevel + 1);
        console.warn(`⚡ Adaptación de dificultad activada (Nivel de Ayuda ${this.activeHelpLevel}) en Paso ${stepNumber}`);

        // 1. Notificar a EventBus
        if (window.EventBus) {
            window.EventBus.emit('ADAPTATION_TRIGGERED', {
                stepNumber,
                helpLevel: this.activeHelpLevel,
                context
            });
        }

        // 2. Respuesta Háptica de aviso suave
        if (window.HapticsService) {
            window.HapticsService.notification('warning');
        }

        // 3. Intervención hablada del Detective Mentor
        if (window.DetectiveMentor && typeof window.DetectiveMentor.speak === 'function') {
            const messages = [
                '¡No te preocupes, detective! Te he activado pistas visuales para ayudarte.',
                'Fíjate bien en las pistas marcadas en amarillo. ¡Tú puedes lograrlo!'
            ];
            window.DetectiveMentor.speak(messages[this.activeHelpLevel - 1] || messages[0], 'info');
        }

        // 4. Registrar error en la taxonomía xAPI para analítica docente
        if (window.ScormManager && typeof window.ScormManager.recordCategorizedError === 'function') {
            const errorTypes = {
                1: 'COMPREHENSION_ERROR',
                2: 'COMPREHENSION_ERROR',
                3: 'REPRESENTATION_ERROR',
                4: 'OPERATION_SELECTION_ERROR',
                5: 'CALCULATION_ERROR',
                6: 'COMPREHENSION_ERROR'
            };
            window.ScormManager.recordCategorizedError(stepNumber, errorTypes[stepNumber] || 'CALCULATION_ERROR', context);
        }
    }

    /**
     * Refuerzo positivo por racha excelente
     */
    triggerPositiveReinforcement(stepNumber) {
        console.log(`🌟 Racha brillante detectada en Paso ${stepNumber}`);
        if (window.HapticsService) {
            window.HapticsService.notification('success');
        }
    }
}

export const DynamicAdapter = new DynamicAdapterManager();

if (typeof window !== 'undefined') {
    window.Detectimaticas = window.Detectimaticas || {};
    window.Detectimaticas.DynamicAdapter = DynamicAdapter;
    window.DynamicAdapter = DynamicAdapter;
}
